module.exports = __webpack_public_path__ + "img/stamp-expired.8f1f3b0e.png";